export default {
    name: 'ContentBox',
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        tooltipText: {
            type: String,
            default: ''
        },
        tooltipClassSelector: {
            type: String,
            default: ''
        },
        loader: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({}),
    async created() {},
    methods: {}
};
